import { compose } from 'redux';
import { createSelector } from 'reselect';
import type { LoginState } from './reducer';

import type { Session, SessionUser } from '@cobliteam/common-types';

import { mapWebData } from '@cobliteam/api-lib';

import type { AppState } from '../AppState';

const selectLoginDomain = (state: AppState): LoginState => state.login;

export const selectLoginWebData = compose((domainState: LoginState) => domainState.loginWebData, selectLoginDomain);

const mapLoggedUser = (session: Session) => session.user;

export const selectLoginUserWebData = createSelector(selectLoginWebData, mapWebData(mapLoggedUser));

const mapLoggedUserEmail = (user: SessionUser) => user.email;

const mapLoggedUserTimezone = (user: SessionUser) => user.timezone;

export const selectLoginUserEmailWebData = createSelector(selectLoginUserWebData, mapWebData(mapLoggedUserEmail));

export const selectLoginUserTimezoneWebData = createSelector(selectLoginUserWebData, mapWebData(mapLoggedUserTimezone));
